import { render, staticRenderFns } from "./OnechatGeneralConsent.vue?vue&type=template&id=5434854c&scoped=true&"
import script from "./OnechatGeneralConsent.vue?vue&type=script&lang=js&"
export * from "./OnechatGeneralConsent.vue?vue&type=script&lang=js&"
import style0 from "./OnechatGeneralConsent.vue?vue&type=style&index=0&id=5434854c&prod&lang=css&"
import style1 from "./OnechatGeneralConsent.vue?vue&type=style&index=1&id=5434854c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434854c",
  null
  
)

export default component.exports